var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3388_12283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 14.667C11.6798 14.667 14.6665 11.6803 14.6665 8.00033C14.6665 4.32032 11.6798 1.33366 7.99984 1.33366C4.31984 1.33366 1.33317 4.32032 1.33317 8.00033C1.33317 11.6803 4.31984 14.667 7.99984 14.667ZM7.33317 4.66699H8.6665L8.6665 6.00033H7.33317L7.33317 4.66699ZM7.33317 7.33366H8.6665L8.6665 11.3337H7.33317L7.33317 7.33366Z",
    fill: "#0A86E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3388_12283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 -1 16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.12c1093bdd7c104a1dcd62c8bee47602.svg";
export { ForwardRef as ReactComponent };